import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import cn from 'classnames';

import DateTimeComponent from 'components/Form/DateTime';
import Header from 'components/Header';
import Heading from 'components/Heading';
import Footer from 'components/Footer';
import FormGroup from 'components/Form/FormGroup';
import Input from 'components/Form/Input';
import FormGroupLabel from 'components/FormGroupLabel';
import { Button } from 'components/Button';
import Modal from 'components/Modal/AnimatedModal';
import Checkbox from 'components/Form/Checkbox';

import { parseUrlParams } from 'utils/parseUrlParams';
import { getOffers } from 'actions/application';

import {
  nextAction,
} from 'actions/workflow';

import style from './style.scss';

const CreditAppDecision = (props) => {
  const dispatch = useDispatch();
  const [response, setResponse] = useState({
    offers: null,
  });
  const [isModalShown, setIsModalShown] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [purchaseDate, setPurchaseDate] = useState('');
  const [signature, setSignature] = useState('');

  useEffect(() => {
    const params = parseUrlParams(window.location.search);

    if (params.applicationId) {
      dispatch(getOffers({
        url: '/offers/application/2002075/active',
        success: (res) => {
          setResponse(res);
        },
      }));
    } else {
      props.history.push('/dashboard/borrowers-merchant');
    }
  }, []);

  const toggleModal = () => {
    setIsModalShown(!isModalShown);
  };

  const handleCheckboxChange = (name, value) => {
    setIsChecked(value);
  };

  const handleFinalizeSale = (e) => {
    e.preventDefault();

    const params = parseUrlParams(window.location.search);
    if (params.applicationId) {
      setIsLoading(true);
      dispatch(nextAction({
        data: {},
        url: `/workflows/application/${params.applicationId}/workflow/dtm/next`,
        success: (res) => {
          setIsLoading(false);
          const routeUrl = res.state && res.state.url;
          props.history.push(routeUrl);
        },
        fail: () => {},
      }));
    }
  };

  const handleSelect = (selectedIndexArg, e) => {
    e.preventDefault();
    setSelectedIndex(selectedIndexArg);
  };

  const handleDisplayModal = (e) => {
    e.preventDefault();
    setIsModalShown(true);
  };

  const handleChange = (e) => {
    e.preventDefault();
    setSignature(e.target.value);
  };

  return (
    <Fragment>
      <Header />
      <section className="grid-container fluid borrowers-apply section">
        <div className="grid-container">
          <div className="grid-x grid-margin-x max-limited">
            {
              <Fragment>
                <Heading
                  heading="Select Loan Offer"
                  isCardVisible={false}
                  className="large-offset-2 large-8"
                />
                <div className="cell small-12 large-8 large-offset-2">
                  <FormGroup className="form-group">
                    <h4>Confirm Amount of Sale</h4>
                    <div className="grid-x grid-margin-x">
                      <div className="cell small-12 medium-6">
                        <label className="has-value"><span>Pre-Approval Amount</span>
                          <Input
                            name="serviceOfProductTotal"
                            label="Pre-Approval Amount"
                            value={`${response && response.requestedAmount}`}
                            isBadgeVisible={false}
                            readOnly
                          />
                        </label>
                      </div>
                      <div className="cell small-12 medium-6">
                        <label className="has-value"><span>Confirm Service or Product Total</span>
                          <Input
                            name="serviceOfProductTotal"
                            label="Confirm Service of Product Total"
                            onChange={() => {}}
                            value={`${response && response.maxAmount}`}
                            isRequired
                            notification="Changing the total will update the estimated monthly payment"
                            isBadgeVisible={false}
                          />
                        </label>
                      </div>
                    </div>
                  </FormGroup>
                  <FormGroup className="form-group">
                    <FormGroupLabel value="Select an offer and comfirm amount" />
                    <div className="grid-x">
                      {// eslint-disable-next-line
                        response.offers && response.offers.map((item, key) => (
                          <div
                            key={key}
                            className={cn('card loan-card', style['loan-card'], style.active, key === selectedIndex && style.selected)}
                            onClick={handleSelect.bind(null, key)}
                          >
                            <div className="grid-x">
                              <div className={cn('cell small-12 medium-4 highlight', style.cell, style.highlight)}>
                                <h5>Estimated<br className="show-for-large" /> Monthly Payment</h5>
                                <h3>${item.paymentAmount}</h3>
                                <small className={style.small}>Offer #220190</small>
                                {
                                  key === selectedIndex ?
                                    <Button
                                      className={cn('button secondary w-100 btn-select-toggle green', style.selectedButton)}
                                    >
                                      Selected
                                    </Button>
                                  :
                                    <Button
                                      className={cn('button secondary w-100 btn-select-toggle', style.selectButton)}
                                    >
                                      Select
                                    </Button>
                                }
                              </div>
                              <div className={cn('cell small-12 medium-8', style.cell)}>
                                <div className="grid-x">
                                  <div className="cell small-6">
                                    <h5>Amount Financed</h5>
                                  </div>
                                  <div className="cell small-6">
                                    <h5><em>${item.offerAmount}</em></h5>
                                  </div>
                                </div>
                                <div className="grid-x">
                                  <div className="cell small-6">
                                    <h5>Loan Term</h5>
                                  </div>
                                  <div className="cell small-6">
                                    <h5><em>{item.term} Months</em></h5>
                                  </div>
                                </div>
                                <div className="grid-x">
                                  <div className="cell small-6">
                                    <h5>Interest Rate</h5>
                                  </div>
                                  <div className="cell small-6">
                                    <h5><em>{item.rate}%</em></h5>
                                  </div>
                                </div>
                                <div className="grid-x">
                                  <div className={cn('cell small-12 promo-message', style.promoMessage)}>
                                    <p><em>Special Promotion:</em>  No Interest on principal if your loan is paid in full within the first six months</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      }
                      <Button
                        className="button large arrow green w-100"
                        isDisabled={selectedIndex === null}
                        onClick={handleDisplayModal}
                      >
                        Review &amp; Confirm Your Loan
                      </Button>
                    </div>
                  </FormGroup>
                </div>
              </Fragment>
            }

          </div>
        </div>
      </section>
      <Footer />
      <Modal
        className={style.modal}
        isShown={isModalShown}
        onClose={toggleModal}
        canBeClosedByEsc
        isLogoShown={false}
      >
        <div className={style['card-header']}>
          <h5>Please Confirm the Following</h5>
        </div>
        <div className="grid-x">
          <div className="cell small-12">
            <FormGroup className={cn('form-group', style.formGroup)}>
              <div className="grid-x grid-margin-x">
                <div className="cell small-12 medium-6">
                  <Input
                    name="channel.attributes.serviceProvider.phone"
                    label="Pre-Approval Amount"
                    onChange={() => {}}
                    isBadgeVisible={false}
                    value={`$${response.offers && response.offers[selectedIndex] && response.offers[selectedIndex].offerAmount}`}
                    isDisabled
                  />
                </div>
                <div className="cell small-12 medium-6">
                  <DateTimeComponent
                    name="channel.attributes.serviceProvider.phone"
                    label="Purchase/Service Date"
                    onChange={(value) => { setPurchaseDate(value.format('MM/DD/YYYY')); }}
                    timeFormat={false}
                    dateFormat="MM/DD/YYYY"
                    value={purchaseDate}
                    isBadgeVisible={false}
                  />
                </div>
                <div className="cell small-12 medium-6">
                  <Input
                    name="channel.attributes.serviceProvider.phone"
                    label="Confirm Service or Product Total"
                    onChange={() => {}}
                    isBadgeVisible={false}
                    value={`${response && response.maxAmount}`}
                    isDisabled
                  />
                </div>
              </div>
              <div className="cell small-12 checkbox-row padded-bottom">
                <Checkbox
                  label={['I certify that the amount taken only includes services or products to be rendered. No origination fees or any other finance fees have been added. Non compliances will result in all funds being charged back and loan cancellation. Additionally, it is understood that I am not to attempt to collect additional fees directly from the customer in order to make up for the discount fees that I am incurring.']}
                  name="hasApplicationConsented"
                  onChange={handleCheckboxChange.bind(null, 'isChecked')}
                  isChecked={isChecked}
                  id="hasApplicationConsented"
                />
              </div>
              <div className="cell small-12 checkbox-row padded-bottom">
                <Checkbox
                  label={['I certify that I have identified the borrower with a valid government issued ID and have retained a copy for my records which will be provided to LendingUSA upon request.']}
                  name="isCertified"
                  onChange={handleCheckboxChange.bind(null, 'isChecked')}
                  isChecked={isChecked}
                  id="isCertified"
                />
              </div>
              <div className="cell small-12">
                <Input
                  name="channel.attributes.serviceProvider.phone"
                  label="Authorized Representative Signature"
                  onChange={handleChange}
                  isBadgeVisible={false}
                  value={signature}
                />
              </div>
              <Button
                className={cn('button large arrow green w-100', style.button)}
                onClick={handleFinalizeSale}
                isLoading={isLoading}
              >
                Finalize Loan Sale
              </Button>
            </FormGroup>
          </div>
        </div>
      </Modal>
    </Fragment>
  );
};

CreditAppDecision.propTypes = {
  history: PropTypes.object.isRequired,
};

CreditAppDecision.defaultProps = {
};

export default withRouter(CreditAppDecision);



// WEBPACK FOOTER //
// ./src/containers/pages/BorrowerMerchantApply/InternalPages/CreditAppDecision/index.js